import * as firebase from 'firebase'
// import 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyCeMAn_MRcykyZLYxNo4RvH-97VGmgW8Vo',
  authDomain: 'mo-transportation.firebaseapp.com',
  databaseURL: 'https://mo-transportation-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'mo-transportation',
  storageBucket: 'mo-transportation.appspot.com',
  messagingSenderId: '791008746767',
  appId: '1:791008746767:web:68ca7cd50197676775b27a',
  measurementId: 'G-SPLQJTFQ2D'
}

const app = firebase.initializeApp(firebaseConfig)

const firestore = app.firestore()

const storing = app.storage()

export default { firestore, storing, app }
